import { extendTheme } from "@chakra-ui/react";
import { config } from "./config";
import { colors } from "./colors";
import { fonts, fontSizes, lineHeights } from "./typography";
import components from "./components";


// import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

// const config = defineConfig({
//   theme: {
//     semanticTokens: {
//       colors: {
//         // Background colors
//         bg: {
//           DEFAULT: {
//             value: {
//               _light: "{colors.white}",
//               _dark: "#121417", // Your custom dark background
//             },
//           },
//           subtle: {
//             value: {
//               _light: "{colors.gray.50}",
//               _dark: "#2d2d2d", // Slightly lighter for cards
//             },
//           },
//           muted: {
//             value: {
//               _light: "{colors.gray.100}",
//               _dark: "#3a3a3a", // Even lighter for hover states
//             },
//           },
//         },
//         // Foreground/text colors
//         fg: {
//           DEFAULT: {
//             value: {
//               _light: "{colors.black}",
//               _dark: "#e5e5e5", // Light text for dark mode
//             },
//           },
//           muted: {
//             value: {
//               _light: "{colors.gray.600}",
//               _dark: "#a3a3a3", // Muted text for dark mode
//             },
//           },
//         },
//         // Border colors
//         border: {
//           DEFAULT: {
//             value: {
//               _light: "{colors.gray.200}",
//               _dark: "#404040", // Border for dark mode
//             },
//           },
//         },
//       },
//     },
//   },
// });

// const system = createSystem(defaultConfig, config);

const globalTheme = extendTheme({
  config,
  colors,
  fonts,
  fontSizes,
  lineHeights,
  components,
});

const theme = extendTheme(globalTheme);

theme.background = { content: colors.white };

// export default system;
export { theme };
